module.exports = __webpack_public_path__ + "media/images/city/007-cctv-headquarters-a8b2ecfe809b37a1e1cbbb633759839e.svg";